import id from './{id}';
import query from './query';
import get from './get';
import post from './post';
import { FolderType } from '../../index';

export type PostPayload = {
  information?: FolderType['information'];
  location?: FolderType['location'];
  metadata?: FolderType['metadata'];
  name: FolderType['name'];
  parentFolderId: FolderType['parentFolderId'];
  tags?: FolderType['tags'];
  theme: FolderType['theme'];
  timezone: string;
  type: FolderType['type'];
};
export default { id, query, get, post };
